import { useEffect } from "react";
import { Loader2, Star } from "lucide-react";
import SpyAdCard from "./SpyAdCard";
import { useAdsSpyStore } from "../store/adsSpyStore";
import { dictionary, Language } from "@/utils/dictionary";
import { useAuth } from "@/context/AuthContext";

interface BookmarksGridProps {
  onClickDetail: (id: number) => void;
}

export default function BookmarksGrid({ onClickDetail }: BookmarksGridProps) {
  const { language } = useAuth();
  const lang = language as Language;
  const t = (key: string, fallback: string) => dictionary[key]?.[lang] ?? fallback;
  const { bookmarks, bookmarksLoading, loadBookmarks, toggleBookmark, markAdExpired } =
    useAdsSpyStore();

  useEffect(() => {
    loadBookmarks();
  }, [loadBookmarks]);

  if (bookmarksLoading && bookmarks.length === 0) {
    return (
      <div className="flex justify-center py-16">
        <Loader2 className="w-5 h-5 animate-spin text-[#5050EA]" />
      </div>
    );
  }

  if (!bookmarksLoading && bookmarks.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-28">
        <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5 bg-amber-50">
          <Star className="w-7 h-7 text-amber-300" />
        </div>
        <p className="text-sm font-medium text-gray-500">
          {t("no-bookmarks-yet", "No bookmarks yet")}
        </p>
        <p className="text-xs mt-1.5 text-gray-400">
          {t("click-star-to-save", "Click the star on any ad to save it")}
        </p>
      </div>
    );
  }

  return (
    <div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-5">
        {bookmarks.map((ad) => (
          <SpyAdCard
            key={ad.id}
            ad={ad}
            onClickDetail={onClickDetail}
            onToggleBookmark={toggleBookmark}
            onMediaError={markAdExpired}
          />
        ))}
      </div>
    </div>
  );
}
